import React, { useState } from "react";
import {
  Grid,
  TextField,
  Typography,
  Box,
  Button,
  
  IconButton,
  
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";


const MedicationsTab = ({ data, onChange }) => {
  console.log("💊 MedicationsTab received data:", data);

  const handleAdd = () => {
    const newMeds = [
      ...data,
      { name: "", dosage: "", frequency: "", startDate: "", notes: "" },
    ];
    console.log("➕ Adding new medication, new array:", newMeds);
    onChange(newMeds);
  };

  const handleRemove = (index) => {
    const newMeds = data.filter((_, i) => i !== index);
    console.log(
      "🗑️ Removing medication at index",
      index,
      "new array:",
      newMeds
    );
    onChange(newMeds);
  };

  const handleChange = (index, field, value) => {
    const updated = [...data];
    updated[index] = { ...updated[index], [field]: value };
    console.log(
      `✏️ Updating medication ${index}, field ${field}, value:`,
      value
    );
    onChange(updated);
  };

  console.log("💊 Rendering", data.length, "medications");

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 3,
        }}
      >
        <Typography variant="h6" color="primary">
          Current Medications
        </Typography>
        <Button startIcon={<AddIcon />} onClick={handleAdd} variant="contained">
          Add Medication
        </Button>
      </Box>

      {data && data.length > 0 ? (
        data.map((med, index) => (
          <Box
            key={index}
            sx={{ mb: 3, p: 2, border: "1px solid #ddd", borderRadius: 1 }}
          >
            <Grid container spacing={2}>
              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  label="Medication Name"
                  value={med.name || ""}
                  onChange={(e) => handleChange(index, "name", e.target.value)}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  fullWidth
                  label="Dosage"
                  value={med.dosage || ""}
                  onChange={(e) =>
                    handleChange(index, "dosage", e.target.value)
                  }
                  placeholder="e.g., 10mg"
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  fullWidth
                  label="Frequency"
                  value={med.frequency || ""}
                  onChange={(e) =>
                    handleChange(index, "frequency", e.target.value)
                  }
                  placeholder="e.g., Twice daily"
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <TextField
                  fullWidth
                  label="Start Date"
                  type="date"
                  value={med.startDate || ""}
                  onChange={(e) =>
                    handleChange(index, "startDate", e.target.value)
                  }
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={12} md={11}>
                <TextField
                  fullWidth
                  label="Notes"
                  value={med.notes || ""}
                  onChange={(e) => handleChange(index, "notes", e.target.value)}
                  multiline
                  rows={2}
                />
              </Grid>
              <Grid
                item
                xs={12}
                md={1}
                sx={{ display: "flex", alignItems: "center" }}
              >
                <IconButton color="error" onClick={() => handleRemove(index)}>
                  <DeleteIcon />
                </IconButton>
              </Grid>
            </Grid>
          </Box>
        ))
      ) : (
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ fontStyle: "italic" }}
        >
          No medications recorded. Click "Add Medication" to get started.
        </Typography>
      )}
    </Box>
  );
};

export default MedicationsTab;
